import script from "./SliderNewMobileYoutube.vue?vue&type=script&setup=true&lang=js"
export * from "./SliderNewMobileYoutube.vue?vue&type=script&setup=true&lang=js"

import "./SliderNewMobileYoutube.vue?vue&type=style&index=0&id=45b69e6c&lang=scss"
import "./SliderNewMobileYoutube.vue?vue&type=style&index=1&id=45b69e6c&lang=scss&scoped=true"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45b69e6c"]])

export default __exports__